import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { Status } from '~/modules/ddex-console/api/lib/types';

export const useURLFilters = (filters: string[]) => {
  const [searchParams] = useSearchParams();

  return React.useMemo(() => {
    if (filters.length) {
      return filters.reduce<Record<string, unknown>>((acc, key) => {
        const value = searchParams.get(key);

        if (value !== null) {
          if (key === 'statuses' && value === 'success') {
            acc[key] = [Status.success, Status.needs_attention];
          } else {
            acc[key] = value;
          }
        }

        return acc;
      }, {});
    }

    return Object.fromEntries(searchParams);
  }, [filters, searchParams]);
};
